import type { Address, UpdateAddressInput } from '@/gql/graphql';

const valueOrExisting = <T>(value: T | null | undefined, existing: T) =>
  value === undefined ? existing : value;

export const mergeOptimisticAddressUpdate = <
  T extends Pick<
    Address,
    | 'line1'
    | 'line2'
    | 'city'
    | 'administrativeArea'
    | 'postalCode'
    | 'country'
    | 'contacts'
  >,
>(
  address: T,
  update: UpdateAddressInput
) => ({
  ...address,
  line1: valueOrExisting(update.line1, address.line1),
  line2: valueOrExisting(update.line2, address.line2),
  city: valueOrExisting(update.city, address.city),
  administrativeArea: valueOrExisting(
    update.administrativeArea,
    address.administrativeArea
  ),
  postalCode: valueOrExisting(update.postalCode, address.postalCode),
  country: valueOrExisting(update.country, address.country),
  fullLocalAddress: [
    valueOrExisting(update.line1, address.line1),
    valueOrExisting(update.line2, address.line2),
    valueOrExisting(update.city, address.city),
    valueOrExisting(update.administrativeArea, address.administrativeArea),
    valueOrExisting(update.postalCode, address.postalCode),
    valueOrExisting(update.country, address.country),
  ]
    .filter(Boolean)
    .join(', '),
  contacts:
    update.contacts == null
      ? address.contacts
      : update.contacts.map((contact) => ({
          ...contact,
          id: contact.id || 'temp-id',
          // Placeholder until the onSettled refetch returns the real publicId.
          publicId: contact.id || 'temp-id',
        })),
});
